module.exports = __webpack_public_path__ + "assets/img/cars.1e2dcc00.svg";